import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useTheme } from "styled-components";
import { Flex } from "../Box";
import StyledToggle, { Input, Handle } from "./StyledToggle";
import { scales } from "./types";
var Toggle = function(_param) {
    var checked = _param.checked, _defaultColor = _param.defaultColor, defaultColor = _defaultColor === void 0 ? "input" : _defaultColor, _checkedColor = _param.checkedColor, checkedColor = _checkedColor === void 0 ? "success" : _checkedColor, _scale = _param.scale, scale = _scale === void 0 ? scales.LG : _scale, toogle = _param.toogle, startIcon = _param.startIcon, endIcon = _param.endIcon, props = _object_without_properties(_param, [
        "checked",
        "defaultColor",
        "checkedColor",
        "scale",
        "toogle",
        "startIcon",
        "endIcon"
    ]);
    var isChecked = !!checked;
    var theme = useTheme();
    return theme.isDark ? /*#__PURE__*/ _jsxs(StyledToggle, {
        $checked: isChecked,
        $checkedColor: checkedColor,
        $defaultColor: defaultColor,
        scale: scale,
        style: {
            backgroundColor: toogle !== "toogle" ? "#2D2B38" : toogle === "toogle" && isChecked ? "#7D9CD1" : toogle === "toogle" && !isChecked ? "#5E5C71" : "rgba(236, 228, 253, 0.5)",
            border: toogle !== "toogle" ? "1px solid #FFFFFF" : ""
        },
        children: [
            /*#__PURE__*/ _jsx(Input, _object_spread_props(_object_spread({
                checked: checked,
                scale: scale
            }, props), {
                type: "checkbox"
            })),
            startIcon && endIcon ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !theme.isDark ? /*#__PURE__*/ _jsx(Handle, {
                        scale: scale,
                        children: /*#__PURE__*/ _jsx(Flex, {
                            height: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            children: checked ? endIcon(checked) : startIcon(!checked)
                        })
                    }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                    /*#__PURE__*/ _jsxs(Flex, {
                        width: "100%",
                        height: "100%",
                        justifyContent: "space-around",
                        alignItems: "center",
                        children: [
                            startIcon(),
                            endIcon()
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsx(Handle, {
                scale: scale,
                style: {
                    background: isChecked && toogle === "toogle" ? "black" : "#9F9DAD"
                }
            })
        ]
    }) : /*#__PURE__*/ _jsxs(StyledToggle, {
        $checked: isChecked,
        $checkedColor: checkedColor,
        $defaultColor: defaultColor,
        scale: scale,
        style: {
            backgroundColor: toogle !== "toogle" ? "#FF624B" : toogle === "toogle" && isChecked ? "#7D9CD1" : toogle === "toogle" && !isChecked ? "#ffff" : "white"
        },
        children: [
            /*#__PURE__*/ _jsx(Input, _object_spread_props(_object_spread({
                checked: checked,
                scale: scale
            }, props), {
                type: "checkbox"
            })),
            startIcon && endIcon ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Handle, {
                        scale: scale,
                        children: /*#__PURE__*/ _jsx(Flex, {
                            height: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            children: checked ? endIcon(checked) : startIcon(!checked)
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        width: "100%",
                        height: "100%",
                        justifyContent: "space-around",
                        alignItems: "center",
                        children: [
                            startIcon(),
                            endIcon()
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsx(Handle, {
                scale: scale,
                style: {
                    background: isChecked && toogle === "toogle" ? "white" : "#A4AFC1"
                }
            })
        ]
    });
};
export default Toggle;
